import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SelectionService {
  private readonly selectedRowsMap: Map<string, any> = new Map();

  public add(key: string, row: any) {
    this.selectedRowsMap.set(key, row);
  }

  public remove(key: string) {
    this.selectedRowsMap.delete(key);
  }

  public has(key: string) {
    return this.selectedRowsMap.has(key);
  }

  public getAllRows() {
    return Array.from(this.selectedRowsMap.values());
  }

  public getAllKeys() {
    return Array.from(this.selectedRowsMap.keys());
  }

  public getRow(key: string) {
    return this.selectedRowsMap.get(key);
  }

  public clear() {
    this.selectedRowsMap.clear();
  }

  public size() {
    return this.selectedRowsMap.size;
  }

  public hasAny() {
    return this.selectedRowsMap.size > 0;
  }
}
